import { Card, Row, Col } from "react-bootstrap";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { ParseDate } from "../../../../../Helpers/DateHelper";
import IconSvg from "../../../../SharedComponents/IconSvg";
import ScrollableCard from "../../../../SharedComponents/ScrollableCard";
import { getB2bAssessments } from "../../../../SuperAdmin/CreateCompany/Credits/Store/Thunk";
import { useNavigate } from "react-router-dom";

const ProjectHistory = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const assessmentList = useSelector((state) => state.credits.assessmentList);
  const lastTenOrderRecords = useSelector((state) => state.projects.lastTenOrderRecords);

  useEffect(() => {
    dispatch(getB2bAssessments());
  }, []);

  const MatchAssessmentIdWithName = (id) => {
    const matchingAssessment = assessmentList.find((assessment) => assessment.id === id);
    return matchingAssessment?.name;
  };

  return (
    <Card className={"default-list"} style={{ backgroundColor: "#f8f9fa" }}>
      <Card className={"header mb-0 d-none d-lg-block default-card"} style={{ backgroundColor: "white" }}>
        <Row className={"text-20 text-color-gray-light fw-medium"} style={{ height: "50px", margin: "0" }}>
          <Col xs={3} className={"align-content-center"}>
            <Row className={"justify-content-center"}>{t("projectHistoryDateHeader")}</Row>
          </Col>
          <Col className={"align-content-center"}>
            <Row>
              <Col>
                <Row className={"justify-content-center"}>{t("projectHistoryAssessmentHeader")}</Row>
              </Col>
              <Col>
                <Row className={"justify-content-center"}>{t("projectHistoryFullnameHeader")}</Row>
              </Col>
              <Col>
                <Row className={"justify-content-center"}>{t("projectHistoryEmailHeader")}</Row>
              </Col>
              <Col xs={"auto"}>
                <IconSvg icon={"info-box"} width={30} height={30}></IconSvg>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
      <ScrollableCard top={0}>
        {lastTenOrderRecords.map((orderRecord, orderIndex) => {
          const isOnlyItem =
            orderRecord.successfulRegistrations.length + orderRecord.unsuccessfulRegistrations.length === 1;
          return (
            <Card
              key={orderIndex}
              className={"mt-4 list-container text-20 fw-medium text-color-gray-dark default-card"}
              style={{ backgroundColor: "white" }}
            >
              <Row className={"list-row"} style={{ borderBottomWidth: "0px" }}>
                <Col
                  xs={3}
                  className={"align-content-center position-relative d-none d-lg-block"}
                  style={{ borderRight: "2px solid #e7ecef" }}
                >
                  <Row className={"justify-content-center text-color-gray-light"}>
                    {ParseDate(orderRecord.createdAt).date} {ParseDate(orderRecord.createdAt).time}
                  </Row>
                  <div
                    className={"text-16 text-color-gray-light fw-medium position-absolute"}
                    style={{ top: -7, left: 9 }}
                  >
                    ID {orderRecord.id}
                  </div>
                </Col>
                <Col>
                  <Row className={"justify-content-center position-relative d-lg-none "}>
                    <Col xs={"auto"} className={" text-color-gray-light mt-3"}>
                      {ParseDate(orderRecord.createdAt).date} {ParseDate(orderRecord.createdAt).time}
                    </Col>
                    <div
                      className={"text-16 text-color-gray-light fw-medium position-absolute"}
                      style={{ top: -7, left: -3 }}
                    >
                      ID {orderRecord.id}
                    </div>
                    <div className={"d-lg-none position-absolute w-auto translate-middle-y top-50 end-0"}>
                      <IconSvg icon={"tick-box"} width={30} height={30}></IconSvg>
                    </div>
                  </Row>

                  {orderRecord.successfulRegistrations.length !== 0 &&
                    orderRecord.successfulRegistrations.map((registration, i) => {
                      const lastItem =
                        i === orderRecord.successfulRegistrations.length - 1 &&
                        orderRecord.successfulRegistrations.length > 1;

                      return (
                        <Row
                          key={i}
                          className={"hover-bg-darken rounded-0"}
                          onClick={() => {
                            navigate("/candidate", {
                              state: {
                                candidateId: registration.CandidateId,
                                backUrl: "/project",
                              },
                            });
                          }}
                          style={{
                            borderBottom: `${!lastItem && !isOnlyItem ? "2px solid #e7ecef" : "none"}`,
                            paddingBottom: "10px",
                            paddingTop: "10px",
                          }}
                        >
                          <Col xs={12} lg={true} className={"align-content-center"}>
                            {registration.CreditDataList?.map((creditData, i) => {
                              return (
                                <Row key={i + "R"} className={"justify-content-center text-center d-none d-lg-flex"}>
                                  {MatchAssessmentIdWithName(creditData.AssessmentId)}
                                </Row>
                              );
                            })}
                            <Row className={"d-flex d-lg-none justify-content-center mb-2 text-color-gray-light"}>
                              {registration.CreditDataList?.map((creditData, i) => {
                                return (
                                  <Col key={i + "C"} xs={"auto"} className={"text-center"}>
                                    {MatchAssessmentIdWithName(creditData.AssessmentId)}
                                    {i !== registration.CreditDataList.length - 1 && ","}
                                  </Col>
                                );
                              })}
                            </Row>
                          </Col>
                          <Col xs={12} lg={true} className={"align-content-center"}>
                            <Row className={"justify-content-center text-center"}>{registration.Name}</Row>
                          </Col>
                          <Col xs={12} lg={true} className={"align-content-center text-18"}>
                            <Row className={"justify-content-center text-center"}>{registration.UserEmail}</Row>
                          </Col>
                          <Col xs={"auto"} className={"align-content-center d-none d-lg-block"}>
                            <IconSvg icon={"tick-box"} width={30} height={30}></IconSvg>
                          </Col>
                        </Row>
                      );
                    })}
                  {orderRecord.unsuccessfulRegistrations.length !== 0 &&
                    orderRecord.unsuccessfulRegistrations.map((registration, i) => {
                      const firstItem = i === 0;
                      return (
                        <Row
                          key={i}
                          className={"hover-bg-darken rounded-0 position-relative"}
                          onClick={() => {
                            navigate("/candidate", {
                              state: {
                                candidateId: registration.CandidateId,
                                backUrl: "/project",
                              },
                            });
                          }}
                          style={{
                            borderTop: `${!firstItem && !isOnlyItem ? "2px solid #e7ecef" : "none"}`,
                            paddingBottom: "10px",
                            paddingTop: "10px",
                          }}
                        >
                          <Col xs={12} lg={true} className={"align-content-center"}>
                            {registration.CreditDataList?.map((creditData, i) => {
                              return (
                                <Row key={i + "R"} className={"justify-content-center text-center d-none d-lg-flex"}>
                                  {MatchAssessmentIdWithName(creditData.AssessmentId)}
                                </Row>
                              );
                            })}
                            <Row className={"d-flex d-lg-none justify-content-center mb-2 text-color-gray-light"}>
                              {registration.CreditDataList?.map((creditData, i) => {
                                return (
                                  <Col key={i + "C"} xs={"auto"} className={"text-center"}>
                                    {MatchAssessmentIdWithName(creditData.AssessmentId)}
                                    {i !== registration.CreditDataList.length - 1 && ","}
                                  </Col>
                                );
                              })}
                            </Row>
                          </Col>
                          <Col xs={12} lg={true} className={"align-content-center"}>
                            <Row className={"justify-content-center text-center"}>{registration.Name}</Row>
                          </Col>
                          <Col xs={12} lg={true} className={"align-content-center text-18"}>
                            <Row className={"justify-content-center text-center"}>{registration.UserEmail}</Row>
                          </Col>
                          <Col xs={"auto"} className={"align-content-center d-none d-lg-block"}>
                            <IconSvg icon={"cross-box"} width={30} height={30}></IconSvg>
                          </Col>
                          <div className={"d-lg-none position-absolute w-auto translate-middle-y top-50 end-0"}>
                            <IconSvg icon={"cross-box"} width={30} height={30}></IconSvg>
                          </div>
                        </Row>
                      );
                    })}
                </Col>
              </Row>
            </Card>
          );
        })}
      </ScrollableCard>
    </Card>
  );
};
export default ProjectHistory;
